"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapOptional = exports.mapNullable = exports.isNullish = void 0;
function isNullish(value) {
    return value == null;
}
exports.isNullish = isNullish;
function mapNullable(value, cb) {
    return isNullish(value) ? null : cb(value);
}
exports.mapNullable = mapNullable;
function mapOptional(value, cb) {
    return isNullish(value) ? undefined : cb(value);
}
exports.mapOptional = mapOptional;
//# sourceMappingURL=mapOptional.js.map